import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import store from "./redux/store";
import App from "./App";
import "./index.css";
import "wx-react-gantt/dist/gantt.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import Notification from "components/Elements/Notification";
import ErrorBoundary from "components/Layouts/ErrorBoundaryWrapper/ErrorBoundary";
import { GoogleOAuthProvider } from "@react-oauth/google";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 30_000,
			gcTime: 5 * 60_000,
			retry: 1,
			refetchOnWindowFocus: false,
		},
	},
});

// Configuration object constructed.
const config = {
	auth: {
		clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
	},
};

// create PublicClientApplication instance
const publicClientApplication = new PublicClientApplication(config);
publicClientApplication.initialize();

ReactDOM.createRoot(document.getElementById("root")).render(
	<MsalProvider instance={publicClientApplication}>
		<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
			<Provider store={store}>
				<QueryClientProvider client={queryClient}>
					<ErrorBoundary>
						<App />
						<Notification />
					</ErrorBoundary>
					{process.env.NODE_ENV === "development" && (
						<ReactQueryDevtools initialIsOpen={false} />
					)}
				</QueryClientProvider>
			</Provider>
		</GoogleOAuthProvider>
	</MsalProvider>
);
